module.exports = __webpack_public_path__ + "static/img/花瓶8.510ef21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶8.png
// module id = bfd+
// module chunks = 2